import { GET_TICKET_BY_SHAPE, GET_TICKET_BY_PARAMS, GET_PASSES } from "./../../../../api/apiRoutes";
import { Assort } from "./../../../../models/Assort";
import { useEffect, useState } from "react";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../../utils/hooks/useFacility";
import { GET_TICKET_BY_ASSORTGROUP, GET_TICKET_BY_COLORS } from "../../../../api/apiRoutes";

export default function useTicketsByAssortGroup() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [assorts, setAssortByAssortGroup] = useState<Assort[]>([]);
  const [passes, setPassByAssortGroup] = useState<Assort[]>([]);
  const [passesAndAssorts, setPassesAndAssorts] = useState<Assort[]>([]);

  const requestGetTicketsByAssortGroup = async (objectId: number) => {
    const ids = `0,${objectId}`;
    const { result, isError } = await get(GET_TICKET_BY_ASSORTGROUP(facilityIds, ids));
    if (!isError) {
      setAssortByAssortGroup(result);

      // requestGetPassesByAssortGroup(ids);
    }
  };

  const requestGetPassesByAssortGroup = async (ids: string) => {
    const { result, isError } = await get(GET_PASSES(facilityIds, "", "", ids));
    if (!isError) {
      setPassByAssortGroup([...assorts, ...result]);
    }
  };

  const requestGetTicketsByColor = async (objectDB: number, objectId: number) => {
    const ids = `${objectDB},${objectId}`;
    const { result, isError } = await get(GET_TICKET_BY_COLORS(facilityIds, ids));
    if (!isError) {
      setAssortByAssortGroup(result);
      // requestGetPassesByColor(ids);
    }
  };

  const requestGetPassesByColor = async (ids: string) => {
    const { result, isError } = await get(GET_PASSES(facilityIds, ids));
    if (!isError) {
      setPassByAssortGroup([...assorts, ...result]);
    }
  };

  const requestGetTicketsByShape = async (objectId: number) => {
    const ids = `0,${objectId}`;
    const { result, isError } = await get(GET_TICKET_BY_SHAPE(facilityIds, ids));
    if (!isError) {
      setAssortByAssortGroup(result);
      // requestGetPassesByShape(ids);
    }
  };

  const requestGetPassesByShape = async (ids: string) => {
    // console.log("TEST");
    const { result, isError } = await get(GET_PASSES(facilityIds, "", ids));
    if (!isError) {
      setPassByAssortGroup([...assorts, ...result]);
    }
  };

  const requestGetTicketsByAllParams = async (allParams: {
    colorIds?: string;
    shapeIds?: string;
    assortGroupIds?: string;
    assortIds?: string;
  }) => {
    const { result, isError } = await get(
      GET_TICKET_BY_PARAMS(
        facilityIds,
        allParams.shapeIds,
        allParams.colorIds,
        allParams.assortGroupIds,
        allParams.assortIds
      )
    );
    if (!isError) {
      setAssortByAssortGroup(result);
    }
  };

  useEffect(() => {
    setPassesAndAssorts([...assorts, ...passes]);
  }, [assorts, passes]);

  return {
    requestGetPassesByAssortGroup,
    requestGetPassesByShape,
    requestGetPassesByColor,
    requestGetTicketsByColor,
    requestGetTicketsByAssortGroup,
    requestGetTicketsByShape,
    requestGetTicketsByAllParams,
    assorts,
    passes,
    passesAndAssorts,
  };
}
